import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "edit-prop-container"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "prop-info"
};
const _hoisted_4 = {
  class: "props-name"
};
const _hoisted_5 = {
  class: "props-type"
};
const _hoisted_6 = {
  class: "item-content"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = {
  class: "item-content"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "edit-prop-col"
};
const _hoisted_11 = {
  class: "edit-prop-col"
};
const _hoisted_12 = {
  class: "edit-prop-col"
};
const _hoisted_13 = {
  class: "edit-prop-col"
};
const _hoisted_14 = {
  class: "edit-prop-col"
};
const _hoisted_15 = {
  class: "operator-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElButton, ElCol, ElInput, ElInputNumber, ElMessage, ElOption, ElRow, ElSelect, ElSwitch } from 'element-plus';
import { calculateMD5, compressImage, isAdminType, propsDefaultImage } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import 'element-plus/es/components/input-number/style/css';
export default {
  __name: 'MarketPropsEditCard',
  props: {
    propId: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  emits: ['close', 'reload'],

  setup(__props, {
    emit: __emit
  }) {
    const bindingTypes = [{
      'id': 1,
      'name': '当前选中者'
    }, {
      'id': 2,
      'name': '仅当前角色'
    }, {
      'id': 3,
      'name': '演出中绑定'
    }];
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const data = ref(null);
    const file = ref(null);
    const md5Value = ref(null);
    const imageInput = ref(null);
    const updatesForm = ref({
      id: null,
      times: 0,
      name: '',
      cost: '',
      appearance_desc: '',
      function_desc: '',
      deep_desc: '',
      mysterious_level: 0,
      rare_level: 0,
      price: 0.0,
      weight: 0.0,
      enchant: false,
      fortify: 0,
      detachable: false,
      type: '',
      tag: '',
      cooldown: '',
      timing_type: '',
      binding_type: ''
    }); // computed

    const worldOutlook = computed(() => store.state.world_outlook ?? null);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const propsTypes = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_types ?? [];
    });
    const propsTags = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_tags ?? [];
    });
    const cdTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.cd_types ?? null;
    });
    const timingTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.timing_types ?? null;
    });
    const propTypeStackable = computed(() => {
      if (!data.value) return true;
      return data.value.type.is_stackable ?? true;
    }); // functions

    const getData = () => {
      if (props.propId) {
        request('props/market_props/get/', {
          'prop_id': props.propId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            data.value = response.data;
          }
        });
      }

      if (propsTypes.value.length === 0) {
        store.dispatch('get_props_types');
      }

      if (propsTags.value.length === 0) {
        store.dispatch('get_props_tags');
      }

      if (!cdTypes.value) {
        request('world_outlook/get_cooldown_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'cd_types',
              value: response.data
            });
          }
        });
      }

      if (!timingTypes.value) {
        request('world_outlook/get_timing_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'timing_types',
              value: response.data
            });
          }
        });
      }
    };

    const createProp = () => {
      if (message.value) {
        message.value.close();
      } // console.log(JSON.stringify(updatesForm.value))


      request('props/market_props/create/', { ...updatesForm.value,
        'world_outlook': worldOutlook.value.id
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '道具创建成功',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const updateProp = () => {
      if (message.value) {
        message.value.close();
      } // console.log(JSON.stringify(updatesForm.value))


      request('props/market_props/update/', {
        'updates': updatesForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '道具信息已调整',
          duration: 1500
        });
        getData();
        emits('reload');
      });
    };

    const removeProp = () => {
      if (message.value) {
        message.value.close();
      }

      request('props/market_props/remove/', {
        'prop_id': updatesForm.value.id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '商品已清理',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const clickImage = () => {
      imageInput.value.click();
    };

    const handleInputChange = event => {
      file.value = event.target.files[0];

      if (file.value) {
        compressImage(file.value, 2 * 1024 * 1024, value => {
          file.value = value;
          calculateMD5(file.value, value => {
            // console.log(`md5 = ${value}`)
            md5Value.value = value;
            uploadImage();
          });
        });
      }
    };

    const uploadImage = async () => {
      if (message.value) {
        message.value.close();
      }

      const formData = new FormData();
      formData.append('file', file.value);
      formData.set('name', file.value.name);
      formData.set('path', 'props_images');
      formData.set('md5', md5Value.value);
      formData.set('prop_id', props.propId);
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const response = await request('props/market_props/upload_image/', formData, 'UPLOAD', headers); // console.log(`upload_market_props_image ${JSON.stringify(response)}`)

      if (response.code !== 0) {
        message.value = ElMessage.error(response.msg);
        return;
      }

      message.value = ElMessage.success('上传成功');
      data.value.image = response.data;
      file.value = null;
      md5Value.value = null;
      imageInput.value.value = null;
      emits('reload');
    }; // lifecycle


    onMounted(() => {
      getData();
    }); // watcher

    watch(() => data.value, newValue => {
      if (newValue) {
        // console.log(JSON.stringify(newValue))
        updatesForm.value = {
          id: newValue.id ?? '',
          times: newValue.times ?? 0,
          name: newValue.name ?? '',
          cost: newValue.cost ?? '',
          appearance_desc: newValue.appearance_desc ?? '',
          function_desc: newValue.function_desc ?? '',
          deep_desc: newValue.deep_desc ?? '',
          mysterious_level: newValue.mysterious_level ?? 0,
          rare_level: newValue.rare_level ?? 0,
          price: newValue.price ?? 0.0,
          weight: newValue.weight ?? 0.0,
          enchant: newValue.enchant.toString().toUpperCase() === 'TRUE',
          fortify: newValue.fortify ?? 0,
          detachable: newValue.detachable.toString().toUpperCase() === 'TRUE',
          type: newValue.type?.id ? parseInt(newValue.type?.id) : '',
          tag: newValue.tag?.id ? parseInt(newValue.tag?.id) : '',
          cooldown: newValue.cooldown?.id ? parseInt(newValue.cooldown?.id) : '',
          timing_type: newValue.timing_type?.id ? parseInt(newValue.timing_type?.id) : '',
          binding_type: newValue.binding_type?.id ? parseInt(newValue.binding_type?.id) : ''
        };
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544), __props.propId && data.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        class: "preview-prop-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          class: "prop-image",
          src: data.value.image && data.value.image.length > 0 ? data.value.image : _unref(propsDefaultImage),
          draggable: "false",
          onClick: clickImage
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_4, [_createTextVNode(_toDisplayString(data.value.name) + " ", 1), _createElementVNode("span", _hoisted_5, _toDisplayString(data.value.type.desc) + " / " + _toDisplayString(data.value.tag.desc), 1), _createElementVNode("span", {
            class: _normalizeClass([`rare-${data.value.rare_level}`, 'rare-tag'])
          }, _toDisplayString(data.value.rare_desc), 3)])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "props-desc-row"
        }, {
          default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("text", {
            class: "item-tag"
          }, "形态描述", -1)), _createElementVNode("text", _hoisted_6, "    " + _toDisplayString(data.value['appearance_desc']), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "props-desc-row"
        }, {
          default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("text", {
            class: "item-tag"
          }, "性能描述", -1)), _createElementVNode("text", _hoisted_7, "    " + _toDisplayString(data.value['function_desc']), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "props-desc-row"
        }, {
          default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("text", {
            class: "item-tag"
          }, "深层描述", -1)), _createElementVNode("text", _hoisted_8, "    " + _toDisplayString(data.value['deep_desc']), 1)]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createElementVNode("div", {
          class: "divider"
        }, null, -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "edit-prop-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "align-items": "flex-start"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElCol), {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
                default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("text", {
                  class: "edit-item-title"
                }, "道具名", -1)), _createVNode(_unref(ElInput), {
                  modelValue: updatesForm.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updatesForm.value.name = $event),
                  maxlength: "16",
                  placeholder: "道具名",
                  round: "",
                  type: "text",
                  clearable: "",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[42] || (_cache[42] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "消耗", -1)), _createVNode(_unref(ElInput), {
                modelValue: updatesForm.value.cost,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updatesForm.value.cost = $event),
                maxlength: "128",
                placeholder: "使用消耗",
                round: "",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[24] || (_cache[24] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, [_createTextVNode(" 如果有多项消耗，使用主要效果消耗或者不填消耗，一次性损毁消耗通常不填消耗 "), _createElementVNode("br"), _createTextVNode(" 目前支持的资源写法见cost_desc和resource_desc ")], -1))]),
            _: 1
          }), propTypeStackable.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[27] || (_cache[27] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), propTypeStackable.value ? (_openBlock(), _createBlock(_unref(ElRow), {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "可用次数", -1)), _createVNode(_unref(ElInputNumber), {
                modelValue: updatesForm.value.times,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updatesForm.value.times = $event),
                min: 0,
                max: 999,
                placeholder: "可用次数"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[26] || (_cache[26] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 常规使用无次数限制不损坏，此处写0。多件的套装下方的价值意味着总价值，而非单件价值 ", -1))]),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[43] || (_cache[43] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "神秘等级", -1)), _createVNode(_unref(ElInputNumber), {
                modelValue: updatesForm.value.mysterious_level,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updatesForm.value.mysterious_level = $event),
                min: 1,
                max: 13,
                placeholder: "神秘等级"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[29] || (_cache[29] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, [_createTextVNode(" 神秘等级意味着道具力量的来源是否强大，铸造者或者赐予力量的本源越强大，道具承载的力量越多，相应神秘等级也就越高 "), _createElementVNode("br"), _createTextVNode(" 通常不要超过9，这是世俗的限度，神秘[10,13)之间，意味着已经接近真正的超凡领域 ")], -1))]),
            _: 1
          }), _cache[44] || (_cache[44] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "稀有度", -1)), _createVNode(_unref(ElInputNumber), {
                modelValue: updatesForm.value.rare_level,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updatesForm.value.rare_level = $event),
                min: 0,
                max: 4,
                placeholder: "稀有度"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[31] || (_cache[31] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, [_createTextVNode(" 稀有度仅仅代表物品稀有等级，并不代表强度，高稀有度最直接的价值是高估计回收比例 "), _createElementVNode("br"), _createTextVNode(" 0～4分别代表“常见/少见/珍稀/绝品/传说” ")], -1))]),
            _: 1
          }), _cache[45] || (_cache[45] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), {
            style: {
              "align-items": "flex-start"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElCol), {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
                default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("text", {
                  class: "edit-item-title"
                }, "售价", -1)), _createVNode(_unref(ElInputNumber), {
                  modelValue: updatesForm.value.price,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updatesForm.value.price = $event),
                  min: 0.1,
                  max: 9999,
                  precision: 1,
                  step: 0.1,
                  placeholder: "售价"
                }, null, 8, ["modelValue"]), _cache[33] || (_cache[33] = _createElementVNode("text", {
                  class: "edit-item-tips"
                }, [_createTextVNode(" 价格超过角色持有上限的200则无意义，设计更高是为了迭代结社集资购买可能 "), _createElementVNode("br"), _createTextVNode(" 神话系列物品通常来说会被压价10%～30%的估价，不便于在大众流通。过于珍稀的物品也可能便宜，因为只在小范围内以人情流通 ")], -1))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_unref(ElCol), {
              offset: 2,
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
                default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("text", {
                  class: "edit-item-title"
                }, "重量", -1)), _createVNode(_unref(ElInputNumber), {
                  modelValue: updatesForm.value.weight,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => updatesForm.value.weight = $event),
                  min: 0,
                  max: 9999,
                  precision: 1,
                  step: 0.1,
                  placeholder: "重量"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _cache[35] || (_cache[35] = _createElementVNode("text", {
                class: "edit-item-tips"
              }, " 为0时，视为不计重。对于可堆叠道具类型，至少为0.1时，才会计算堆叠重量 ", -1))]),
              _: 1
            })]),
            _: 1
          }), _cache[46] || (_cache[46] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "是否显露灵能", -1)), _createVNode(_unref(ElSwitch), {
                modelValue: updatesForm.value.enchant,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updatesForm.value.enchant = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[37] || (_cache[37] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 被计入雾海的所有道具至少需要固定沾染能量，是否显露灵能只代表道具常规情况下是否能够感知到能量气息。这也与是否能够与纯灵体交互相关 ", -1))]),
            _: 1
          }), _cache[47] || (_cache[47] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "可拆解性", -1)), _createVNode(_unref(ElSwitch), {
                modelValue: updatesForm.value.detachable,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => updatesForm.value.detachable = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[39] || (_cache[39] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 如果道具可以被拆解成重要资源，如“传奇铸造材料/神格/遗落之物”等，填可拆解，在鉴定后可以使角色在世界中寻找机会拆解获取重要资源。（拆解未必是百分百成功的） ", -1))]),
            _: 1
          }), _cache[48] || (_cache[48] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[40] || (_cache[40] = _createElementVNode("text", {
                class: "edit-item-title"
              }, "可强化性", -1)), _createVNode(_unref(ElInputNumber), {
                modelValue: updatesForm.value.fortify,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => updatesForm.value.fortify = $event),
                min: 0,
                max: 3,
                placeholder: "可强化性"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _cache[41] || (_cache[41] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 0～3分别代表“不可强化/可强化/仍可强化/强化完成”，均指代常规情况强化可能，并不是绝对意义上的限制 ", -1))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 1,
          span: 9
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "gap": "0.5rem",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[49] || (_cache[49] = _createElementVNode("text", {
              class: "edit-item-select-title"
            }, "道具类型", -1)), _createVNode(_unref(ElSelect), {
              modelValue: updatesForm.value.type,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => updatesForm.value.type = $event),
              placeholder: "未指定",
              class: _normalizeClass(updatesForm.value.type ? 'selected-selector' : ''),
              "popper-class": "commonPopper",
              "no-data-text": "无数据"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTypes.value, item => {
                return _openBlock(), _createBlock(_unref(ElOption), {
                  key: item.id,
                  label: item.desc,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "class"])]), _createElementVNode("div", _hoisted_11, [_cache[50] || (_cache[50] = _createElementVNode("text", {
              class: "edit-item-select-title"
            }, "道具标签", -1)), _createVNode(_unref(ElSelect), {
              modelValue: updatesForm.value.tag,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => updatesForm.value.tag = $event),
              placeholder: "未指定",
              class: _normalizeClass(updatesForm.value.tag ? 'selected-selector' : ''),
              "popper-class": "commonPopper",
              "no-data-text": "无数据"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTags.value, item => {
                return _openBlock(), _createBlock(_unref(ElOption), {
                  key: item.id,
                  label: item.desc,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "class"])]), _createElementVNode("div", _hoisted_12, [_cache[51] || (_cache[51] = _createElementVNode("text", {
              class: "edit-item-select-title"
            }, "发动时机", -1)), _createVNode(_unref(ElSelect), {
              modelValue: updatesForm.value.timing_type,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => updatesForm.value.timing_type = $event),
              placeholder: "未指定",
              clearable: "",
              class: _normalizeClass(updatesForm.value.timing_type ? 'selected-selector' : ''),
              "popper-class": "commonPopper",
              "no-data-text": "无数据"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timingTypes.value, (item, index) => {
                return _openBlock(), _createBlock(_unref(ElOption), {
                  key: index,
                  label: item['desc'],
                  value: item['id']
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "class"])]), _createElementVNode("div", _hoisted_13, [_cache[52] || (_cache[52] = _createElementVNode("text", {
              class: "edit-item-select-title"
            }, "冷却时间", -1)), _createVNode(_unref(ElSelect), {
              modelValue: updatesForm.value.cooldown,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => updatesForm.value.cooldown = $event),
              placeholder: "未指定",
              clearable: "",
              class: _normalizeClass(updatesForm.value.cooldown ? 'selected-selector' : ''),
              "popper-class": "commonPopper",
              "no-data-text": "无数据"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdTypes.value, (item, index) => {
                return _openBlock(), _createBlock(_unref(ElOption), {
                  key: index,
                  label: item['desc'],
                  value: item['id']
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "class"])])]),
            _: 1
          }), _cache[60] || (_cache[60] = _createElementVNode("div", {
            style: {
              "height": "0.5rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), {
            style: {
              "gap": "0.5rem",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_cache[53] || (_cache[53] = _createElementVNode("text", {
              class: "edit-item-select-title"
            }, "绑定类型", -1)), _createVNode(_unref(ElSelect), {
              modelValue: updatesForm.value.binding_type,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => updatesForm.value.binding_type = $event),
              placeholder: "未指定",
              clearable: "",
              class: _normalizeClass(updatesForm.value.binding_type ? 'selected-selector' : ''),
              "popper-class": "commonPopper",
              "no-data-text": "无数据"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bindingTypes, (item, index) => {
                return _createVNode(_unref(ElOption), {
                  key: index,
                  label: item['name'],
                  value: item['id']
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue", "class"])]), _cache[54] || (_cache[54] = _createElementVNode("div", {
              class: "edit-prop-col"
            }, null, -1)), _cache[55] || (_cache[55] = _createElementVNode("div", {
              class: "edit-prop-col"
            }, null, -1)), _cache[56] || (_cache[56] = _createElementVNode("div", {
              class: "edit-prop-col"
            }, null, -1))]),
            _: 1
          }), _cache[61] || (_cache[61] = _createElementVNode("div", {
            style: {
              "height": "2.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), {
            class: "form-row"
          }, {
            default: _withCtx(() => [_cache[57] || (_cache[57] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "外观描述", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.appearance_desc,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => updatesForm.value.appearance_desc = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "外观描述",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[62] || (_cache[62] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), {
            class: "form-row"
          }, {
            default: _withCtx(() => [_cache[58] || (_cache[58] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "性能描述", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.function_desc,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => updatesForm.value.function_desc = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "性能描述",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[63] || (_cache[63] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _createVNode(_unref(ElRow), {
            class: "form-row"
          }, {
            default: _withCtx(() => [_cache[59] || (_cache[59] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "深层描述", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.deep_desc,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => updatesForm.value.deep_desc = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "深层描述",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_15, [__props.propId && _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 0,
        class: "remove-prop",
        onClick: removeProp
      }, {
        default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode(" 删除道具 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), __props.propId ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 1,
        onClick: updateProp
      }, {
        default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })) : (_openBlock(), _createBlock(_unref(ElButton), {
        key: 2,
        onClick: createProp
      }, {
        default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode(" 创建商品 ", -1)]))]),
        _: 1
      }))])]);
    };
  }

};